import React from 'react';
interface BadgeProps {
  children: React.ReactNode;
  variant?: 'default' | 'success' | 'warning' | 'error' | 'outline';
  className?: string;
}
export function Badge({
  children,
  variant = 'default',
  className = ''
}: BadgeProps) {
  const variants = {
    default: 'bg-slate-800 text-slate-300',
    success: 'bg-emerald-950 text-emerald-400 border border-emerald-900/50',
    warning: 'bg-amber-950 text-amber-400 border border-amber-900/50',
    error: 'bg-red-950 text-red-400 border border-red-900/50',
    outline: 'border border-slate-700 text-slate-400'
  };
  return <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${variants[variant]} ${className}`} data-id="element-3131">
      {children}
    </span>;
}